import CrudCustom from '../../../libs/custom/CrudCustom';

let PPh21MasaService = new CrudCustom('/p-ph-21-masas');
export default PPh21MasaService;
